<template lang="pug">
.container-servientrega
  h3.capitalize Servientrega
  form(@submit.prevent="")
    .input-container
      input.input(v-model="order" @keyup.enter="getDataOrder" type="text")
      label.label(:class="{ show: order }") Introduce el número de orden

    shActionButton(:isForm="true" :action="getDataOrder" text="Obtener Datos" textRunning="Obteniendo Datos")

  .data-servientrega(v-if="orders.length")
    h3.capitalize Datos
    .table
      table
        thead
          tr.dark
            td Fecha
            td Orden
            td Nombre Cliente
            td Teléfono
            td Ubicación
            td Dirección
            td Ecommerce
            td Cobrar
            td Contanido Paquete
            td Peso
            td Medidas
            td Seguro
        tbody
          tr(v-for="(order, index) in orders")
            td {{ today() }}
            td(@click="deleteOrder(index)") {{ order.brand === 'sahet' ? '' : 'B'}}{{ order.order }}
            td.capitalize {{ order.name }}
            td {{ order.phones[0] }}
            td {{ order.location }} - {{ order.department }}
            td {{ order.address }}
            td {{ order.methodPay === 'cod' ? 'Sí' : 'No' }}
            td {{ order.methodPay === 'cod' ? order.total : '0' }}
            td {{ order.brand === 'sahet' ? 'ropa' : 'visuteria'}}
            td 1
            td {{ order.brand === 'sahet' ? '30 * 27 * 5' : '10 * 10 * 1'}}
            td Mínimo
</template>

<script>
import mForm from '@/mixins/form'
import mFilters from '@/mixins/filters'
import gql from '@my/graphql'
import gqlOrder from '@/graphql/order'
import modals from '@my/store/modals'

export default {
  name: 'Servientrega',

  mixins: [mForm, mFilters],

  props: {
    change: Object
  },

  data () {
    return {
      order: '',
      orders: [],
      company: 'sahet'
    }
  },

  methods: {
    async getDataOrder () {
      if (!this.order || !this.company) return

      const query = gqlOrder.GET_ALL
      const variables = { search: this.order, searchBy: 'order', limit: 1, page: 1, sort: 'createdAt', order: '-' }

      const response = await gql.query(query, variables, true, this.company === 'sahet')
      const docs = response.data.getOrders.docs

      if (!docs.length) {
        modals.showMessage({ message: `No se encontró la orden ${this.order}` })
      } else {
        const orderFound = docs[0]
        const indexOrder = this.orders.findIndex(order => order.order === orderFound.order)
        this.order = ''

        if (indexOrder >= 0) {
          this.orders[indexOrder] = orderFound
          return
        }

        this.orders.push(orderFound)
      }
    },

    deleteOrder (index) {
      this.orders.splice(index, 1)
    },

    today () {
      const date = new Date()
      return `${date.getDate()}/${date.getMonth() + 1}/${date.getFullYear()}`
    },
    quantitySale (order) {
      return 3
    }
  }
}
</script>

<style lang="stylus">
.container-servientrega
  padding 0 3em 1em 3em

.table
  overflow scroll
</style>



// WEBPACK FOOTER //
// src/components/pages/order/Servientrega.vue